import { createAdminBondPreviews } from "./AdminBondPreviews";

export const AdminBondPreviewsClosed = createAdminBondPreviews(
	"admin_bonds_closed",
	(bond) => bond.status === "closed",
);
